import { gql } from '@apollo/client';

export const SAVE_HUB_DELIVERABLE_ZIPCODES = gql`
  mutation SaveHubDeliverableZipcodes($hubId: Long!, $input: HubDeliverableZipcodeTypeInput!) {
    saveHubDeliverableZipcodes(hubId: $hubId, input: $input) {
      hubId
      zipcodes
      totalCount
    }
  }
`;

export interface HubDeliverableZipcodeInput {
  zipcodes: string[];
}

export interface HubDeliverableZipcodeOutput {
  hubId: number;
  zipcodes: string[];
  totalCount: number;
}

export interface SaveHubDeliverableZipcodesResponse {
  saveHubDeliverableZipcodes: HubDeliverableZipcodeOutput;
}

export interface SaveHubDeliverableZipcodesVariables {
  hubId: number;
  input: HubDeliverableZipcodeInput;
}

